<div class="bg">
  <app-suspension-notification>
  </app-suspension-notification>
  <mat-toolbar id="actionbar" color="primary" class="toolbar">
    <button mat-icon-button (click)="goBack()" *ngIf="!isSearchOpened">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <mat-icon *ngIf="!isSearchOpened"
      routerLink="/"
      class="mat-icon-logo cursor-pointer"
      svgIcon="assets:logo_short_eceos_white"
    ></mat-icon>
    <span class="center"></span>
    <span class="side-actions">
      <app-search-box
      *ngIf="showSearch"
      backIcon="arrow_back"
      [placeholder]="searchPlaceholder"
      [showUnderline]="true"
      [defaultOpenOnDesktop]="true"
      (searchDebounce)="onSearchChange($event)"
      (clear)="onSearchClear()"
      ></app-search-box>
      <ng-content select=".actions"></ng-content>
    </span>
  </mat-toolbar>
  <div class="body" [class.loading]="loading">
    <ng-content></ng-content>
  </div>
</div>
